import { Navigate } from 'react-router-dom';
import { userCan } from '../utils/permissionUtils';

/**
 * ProtectedRoute - Checks if user has permission to view a module
 * Redirects to first permitted page if access denied
 */
const ProtectedRoute = ({ user, moduleKey, subPage, alsoAllow, children }) => {
  // Helper function to check if user can view a module
  const canViewModule = (key) => {
    // Super Admin and Admin have full access
    if (user?.role === 'Super Admin' || user?.role === 'Admin') {
      return true;
    }
    
    // Check custom permissions
    if (user?.permissions && user.permissions[key]) {
      return user.permissions[key].view === true;
    }
    
    return false;
  };

  // Get the first permitted page for redirect
  const getFirstPermittedPage = () => {
    const moduleToPath = {
      dashboard: '/',
      motorcycles: '/motorcycles',
      batteries: '/batteries',
      batterySwaps: '/battery-swaps',
      riders: '/riders',
      lessees: '/lessees',
      maintenance: '/maintenance',
      fines: '/fines',
      inbox: '/inbox',
      salik: '/salik',
      talent: '/talent',
      tap: '/tap',
      spares: '/spares',
      insurance: '/insurance',
      invoices: '/invoices',
      reports: '/reports',
      search: '/searchable-dropdown-demo',
      users: '/users',
      approvals: '/approvals'
    };

    // Find first module user has access to
    for (const [module, path] of Object.entries(moduleToPath)) {
      if (canViewModule(module)) {
        return path;
      }
    }

    // Fallback to profile (always accessible)
    return '/profile';
  };

  // Profile is always accessible
  if (moduleKey === null || moduleKey === 'profile') {
    return children;
  }

  // Check if user has permission
  const allowed = subPage ? userCan(user, moduleKey, 'view', subPage) : canViewModule(moduleKey);
  if (allowed || (alsoAllow && userCan(user, alsoAllow[0], 'view', alsoAllow[1]))) {
    return children;
  }

  // Redirect to first permitted page
  const redirectPath = getFirstPermittedPage();
  console.log(`Access denied to ${moduleKey}, redirecting to ${redirectPath}`);
  return <Navigate to={redirectPath} replace />;
};

export default ProtectedRoute;
